/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import type { FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance } from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance';
import {
    instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance,
    FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSON,
    FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped,
    FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSON,
} from './FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance';

/**
 * @type FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenance
 * 
 * @export
 */
export type FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenance = FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance;

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceFromJSON(json: any): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenance {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceFromJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceFromJSONTyped(json: any, ignoreDiscriminator: boolean): FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenance {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance(json)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceFromJSONTyped(json, true);
    }

    return {} as any;
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceToJSON(json: any): any {
    return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceToJSONTyped(json, false);
}

export function FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenanceToJSONTyped(value?: FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsMaintenance | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (instanceOfFxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance(value)) {
        return FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenanceToJSON(value as FxIdDomainSettingsPublicWebClientConfigOptionsLauncherOptionsLauncherMaintenance);
    }

    return {};
}

